var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98999 11H5.98999V22H1.98999V11ZM20.99 17H13.99L11.9 16.27L12.23 15.33L13.99 16H16.81C17.46 16 17.99 15.47 17.99 14.82C17.99 14.33 17.68 13.89 17.22 13.71L9.95999 11H7.98999V20.02L14.99 22L23 19C22.99 17.9 22.1 17 20.99 17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1C14.464 1 12 3.464 12 6.5C12 9.536 14.464 12 17.5 12C20.536 12 23 9.536 23 6.5C23 3.464 20.536 1 17.5 1ZM17.5 10.9C15.0745 10.9 13.1 8.9255 13.1 6.5C13.1 4.0745 15.0745 2.1 17.5 2.1C19.9255 2.1 21.9 4.0745 21.9 6.5C21.9 8.9255 19.9255 10.9 17.5 10.9ZM17.6705 6.027C16.697 5.7795 16.3835 5.51 16.3835 5.1085C16.3835 4.6465 16.818 4.322 17.5385 4.322C18.2975 4.322 18.5835 4.685 18.6055 5.224H19.546C19.5185 4.487 19.0675 3.8105 18.1765 3.5905V2.65H16.895V3.5795C16.0645 3.7555 15.399 4.2945 15.399 5.125C15.399 6.1095 16.2185 6.6045 17.412 6.8905C18.4845 7.1435 18.699 7.523 18.699 7.919C18.699 8.2105 18.4845 8.6835 17.544 8.6835C16.664 8.6835 16.3175 8.2875 16.268 7.7815H15.322C15.377 8.7165 16.07 9.2445 16.895 9.415V10.35H18.182V9.4315C19.018 9.272 19.678 8.7935 19.6835 7.908C19.678 6.698 18.6385 6.28 17.6705 6.027Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonate);
export default __webpack_public_path__ + "static/media/donate.58fea4dfa0d24e4c48b8b3e9a714d604.svg";
export { ForwardRef as ReactComponent };